module.exports = __webpack_public_path__ + "static/media/whale.be8a0bce.svg";